import { Injectable } from '@angular/core';
import { ProductRow } from '@app/lists/shared/list-detail-management/model/list-detail-management-view.model';
import { Store } from '@ngrx/store';
import { PRODUCT_CARD_ANALYTICS_ACTIONS } from './product-card-analytics.actions';
import { ProductCardMessages } from './product-card-constants';
import { TrackingData } from '@panamax/app-state';

interface AnalyticsData {
  divisionApn: string;
  attributes: string;
  primaryProduct: number;
  quickView: number;
  exceptionView?: number;
  exceptionNumberOfSubs?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ProductCardAnalyticsService {
  constructor(private store: Store) {}

  defaultTransform(tracking: TrackingData) {
    return { ...tracking.data };
  }
  processQuickViewClick(productRow: ProductRow) {
    const products = this.createProductAnalytics(productRow);
    this.store.dispatch(
      PRODUCT_CARD_ANALYTICS_ACTIONS.trackProductQuickViewClick({
        tracking: {
          analytics: {
            data: {
              event: ProductCardMessages.quickViewOpenModalEvent,
              capability: ProductCardMessages.quickViewOpenModalCapability,
              modal: {
                name: ProductCardMessages.quickViewModalName,
              },
              products,
            },
            transformFunc: this.defaultTransform,
          },
        },
      }),
    );
  }

  createProductAnalytics(productRow: ProductRow): AnalyticsData[] {
    let analyticsData: AnalyticsData = {
      divisionApn: `${productRow?.summary?.divisionNumber}-${productRow.productNumber}`,
      attributes: productRow?.trackingAttributes,
      primaryProduct: 1,
      quickView: 1,
    };

    if (!productRow.inventory?.available || !productRow.inventory?.isInStock) {
      analyticsData = {
        ...analyticsData,
        exceptionView: 1,
        exceptionNumberOfSubs:
          productRow.inventory?.substituteProducts?.length > 0 &&
          productRow.hasAlternative
            ? 1
            : 0,
      };
    }
    return [analyticsData];
  }
}
